import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, Renderer2, Input } from '@angular/core';
import { ListComponentGeneric } from '../../../../ui/generics';
import { NotificationService } from '../../../../core/services';
import { ComplaintsService } from '../../services/complaints.service';
import { IComplaint } from '../../interfaces/complaint.interface';
import { ComplaintServiceErrorResolverService } from '../../services/error-resolvers/complaint-service-error-resolver.service';
import { getStatusColor, getStatusLabel, ComplaintsStatuses } from '../../enums/statuses.enum';
@Component({
    selector: 'app-complaints-list',
    templateUrl: './complaints-list.component.html',
    styleUrls: ['./complaints-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ComplaintsListComponent extends ListComponentGeneric<IComplaint> implements OnInit {

  @Input() isDasboard = false;

  protected readonly exportedTableVisibleName = 'Reklamationen Liste';
  protected readonly defaultSorting = {
    sortField: 'dateOfReceipt',
    sortOrder: 'descend',
  };

  constructor(
    protected _service: ComplaintsService,
    protected _cdr: ChangeDetectorRef,
    protected _notify: NotificationService,
    protected renderer: Renderer2,
    protected _errorResolver: ComplaintServiceErrorResolverService,
  ) {
    super(_service, _cdr, _notify, renderer, _errorResolver);
  }

  searchColumns = [
    'dateOfReceipt',
    'placeOfReceipt.name',
    'customerName',
    'emailAddress',
    'phoneNumber',
  ];

  statusFilters = [
    { text: 'Offen', value: 'Open' },
    { text: 'In Arbeit', value: 'InProgress' },
    { text: 'Erledigt', value: 'Accepted' },
    { text: 'Abgelehnt', value: 'Rejected' },
  ];

  ngOnInit(): void {
    if (this.isDasboard) {
      this.pageSize = 10;
      this.keepStateDirective = null;
    }

    super.ngOnInit();
  }

  getStatusColor(status: string): string {
    return getStatusColor(status as ComplaintsStatuses);
  }

  getStatusLabel(status: string): string {
    return getStatusLabel(status as ComplaintsStatuses);
  }
}
